import Vue from 'vue'
import { decode } from '@/lib/util'

export default el => new Vue({
  name: 'Benefits',
  el,
  data () {
    const sectionSettings = JSON.parse(decode(el.getAttribute('settings-data'))) || {
      items: [],
      title: '',
      description: '',
      videoUrlMobile: '',
      videoUrlDesktop: '',
      videoSubtitles: '',
      showVideoVolumeButton: false,
      autoPlayVideo: false,
      image: ''
    }
    return {
      ...sectionSettings,
      breakpoints: '(max-width: 767px)|(min-width: 768px)'
    }
  },
  computed: {
    videoUrls() {
      const videoUrls = []
      if (this.videoUrlMobile) videoUrls.push(this.videoUrlMobile)
      if (this.videoUrlDesktop) videoUrls.push(this.videoUrlDesktop)
      return videoUrls
    }
  }
})